"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.nodeType = exports.UiConfigSchema = exports.TaskSchema = void 0;
const zod_1 = require("zod");
const tape_sanitizer_1 = require("@finley-technologies/tape-sanitizer");
exports.TaskSchema = tape_sanitizer_1.JoinTransformationSchema.omit({
    srcDataTape: true,
    joinDataTape: true,
}).extend({
    operation: zod_1.z.literal('join'),
    srcArtifactSlug: zod_1.z.string(),
    joinArtifactSlug: zod_1.z.string(),
});
exports.UiConfigSchema = exports.TaskSchema;
exports.nodeType = 'operation_join';
//# sourceMappingURL=types.js.map